import { motion } from "framer-motion";
import './main-block.scss'

const containerVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            ease: "easeOut",
            when: "beforeChildren",
            staggerChildren: 0.18,
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } }
};

export default function MainBlock() {
    return (
        <motion.div
            className="main-block"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className="container">
                <motion.div
                    className="main-block__wrapper"
                    variants={containerVariants}
                >
                    <motion.h1
                        className="main-block__title"
                        variants={itemVariants}
                    >
                        Global Markets at Your Fingertips
                    </motion.h1>
                    <motion.span
                        className="main-block__subtitle"
                        variants={itemVariants}
                    >
                        One Account. Unlimited Opportunities.
                    </motion.span>
                    <motion.a
                        href={process.env.REACT_APP_LINK}
                        className="main-block__button button"
                        variants={itemVariants}
                        whileHover={{
                            scale: 1.04,
                            boxShadow: "0 2px 24px #fd532f66"
                        }}
                        whileTap={{ scale: 0.96 }}
                    >
                        Open Trading Account
                    </motion.a>
                </motion.div>
            </div>
        </motion.div>
    );
}
